import { ReactNode } from "react";

import { useCohort } from "@/components/user-context";

import { SiteActivationContextProvider } from "./hooks/site-activation-context";
import { SiteActivationSwitcher } from "./site-activation-switcher";

export const SiteActivation = (props: {
    NewUser?: ReactNode;
    ExistingUser?: ReactNode;
}) => {
    const cohort = useCohort();

    return (
        <SiteActivationContextProvider data-testid={cohort}>
            <SiteActivationSwitcher {...props} cohort={cohort} />
        </SiteActivationContextProvider>
    );
};
